import React, { useEffect } from "react";
import $ from "jquery";
import { LocaleLink } from "../../i18n/LocaleLink";
import { useTranslation } from "react-i18next";
import { LOGO } from "../../lib/assets";

export const Sidebar = () => {
  const { t } = useTranslation();

  useEffect(() => {
    $(".menu-tigger").on("click", function () {
      $(".extra-info,.offcanvas-overly").addClass("active");
      return false;
    });
    $(".menu-close,.offcanvas-overly").on("click", function () {
      $(".extra-info,.offcanvas-overly").removeClass("active");
    });
  }, []);

  return (
    <>
      <div className="extra-info">
        <div className="close-icon menu-close">
          <button>
            <i className="far fa-window-close"></i>
          </button>
        </div>
        <div className="logo-side mb-30">
          <LocaleLink to="/">
            <img src={LOGO} alt="Logo" /></LocaleLink>
        </div>
        <div className="side-info mb-30">
          {/* <div className="contact-list mb-30">
            <h4>Dirección</h4>
            <p>
              Calle 123, Ciudad de Bogotá <br />
              Colombia
            </p>
          </div> */}
          <div className="contact-list mb-30">
            <h4>{t("sidebar.phone")}</h4>
            <p>+57 304 408 9089</p>
          </div>
          <div className="contact-list mb-30">
            <h4>{t("sidebar.email")}</h4>
            <p>info@caomei.com.co</p>
          </div>
        </div>
        <ul className="side-instagram list-wrap">
          <li>
            <a href="#">
              <img src="assets/img/images/sb_insta01.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="#">
              <img src="assets/img/images/sb_insta02.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="#">
              <img src="assets/img/images/sb_insta03.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="#">
              <img src="assets/img/images/sb_insta04.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="#">
              <img src="assets/img/images/sb_insta05.jpg" alt="" />
            </a>
          </li>
          <li>
            <a href="#">
              <img src="assets/img/images/sb_insta06.jpg" alt="" />
            </a>
          </li>
        </ul>
        <div className="social-icon-right mt-30">
          <a href="#">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="#">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="#">
            <i className="fab fa-google-plus-g"></i>
          </a>
          <a href="#">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
      <div className="offcanvas-overly"></div>
    </>
  );
};
